import React, { useState } from "react";
import "../../styles/FaqSection.css";

const faqData = [
    {
        question: "What services does Brand Bounce offer as an AI Agency?",
        answer: "We provide AI-driven automation services tailored to your business needs, including workflow automation, content generation, lead engagement, personalized campaigns, and more.",
    },
    {
        question: "How does AI-powered automation benefit my business?",
        answer: "AI-powered automation helps streamline operations, save time, reduce manual labor, and scale your marketing and content strategies efficiently. It enables faster decision-making and enhances customer engagement.",
    },
    {
        question: "How does the AI work in my business processes?",
        answer: "We build custom AI workflows that integrate with your existing tools (CRM, email, social media, etc.) to automate repetitive tasks, generate personalized content, manage campaigns, and provide data-driven insights.",
    },
    {
        question: "Can I get a custom AI automation solution for my business?",
        answer: "Yes, we offer tailored AI automation solutions to match your specific business processes and goals. Our team works with you to design workflows that optimize your operations and growth.",
    },
    {
        question: "How can I start using AI for my business?",
        answer: "You can get started by booking a free consultation call with our team. We'll evaluate your business needs and design an AI-driven automation strategy to help you scale faster and smarter.",
    },
    {
        question: "Is AI automation suitable for small businesses?",
        answer: "Absolutely! AI-driven automation works for businesses of all sizes. Whether you're a startup or an established company, we can design workflows that fit your scale and goals.",
    },
    {
        question: "Do I need technical expertise to work with Brand Bounce?",
        answer: "No, you don't need to be tech-savvy. We provide easy-to-follow solutions and work with you to implement and optimize AI automation in your business, regardless of your technical background.",
    },
    {
        question: "How long does it take to set up AI automation for my business?",
        answer: "The setup time depends on the complexity of your workflows and business requirements. Typically, it can range from a few days to a few weeks, with our team guiding you throughout the process.",
    },
    {
        question: "What industries can benefit from your AI-driven services?",
        answer: "Our AI-driven services are beneficial for a wide range of industries, including marketing agencies, eCommerce, real estate, SaaS, healthcare, and more. We create customized solutions for any business looking to automate processes and grow faster.",
    },
];


const FaqSection = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAnswer = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    return (
        <div className="faq-section">
            <h2 className="faq-title">Frequently Asked Questions</h2>
            <div className="faq-list">
                {faqData.map((faq, index) => (
                    <div
                        key={index}
                        className={`faq-item ${activeIndex === index ? "active" : ""}`}
                        onClick={() => toggleAnswer(index)}
                    >
                        <div className="faq-question">
                            {faq.question}
                            <span className="faq-icon">{activeIndex === index ? "-" : "+"}</span>
                        </div>
                        {activeIndex === index && (
                            <div className="faq-answer">{faq.answer}</div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FaqSection;